import React from 'react';

const RetroBackground = () => {
    return (
        <div className="fixed top-0 left-0 w-full h-full overflow-hidden" style={{ zIndex: -1 }}>
            {/* Base background */}
            <div
                className="absolute inset-0"
                style={{
                    background: 'linear-gradient(to bottom, #000022, #220033)',
                    opacity: 0.9
                }}
            />

            {/* Animated grid */}
            <div
                className="absolute inset-0"
                style={{
                    backgroundImage: `
                        linear-gradient(to right, rgba(128, 0, 255, 0.2) 1px, transparent 1px),
                        linear-gradient(to bottom, rgba(128, 0, 255, 0.2) 1px, transparent 1px)
                    `,
                    backgroundSize: '40px 40px',
                    animation: 'gridMove 20s linear infinite',
                    transform: 'perspective(500px) rotateX(60deg)',
                    transformOrigin: 'center center'
                }}
            />

            {/* Floating shapes */}
            {[...Array(10)].map((_, i) => (
                <div
                    key={i}
                    className="absolute rounded-full opacity-30"
                    style={{
                        left: `${Math.random() * 100}%`,
                        top: `${Math.random() * 100}%`,
                        width: `${Math.random() * 100 + 20}px`,
                        height: `${Math.random() * 100 + 20}px`,
                        background: `radial-gradient(circle at center, 
                            rgba(255, ${Math.random() * 255}, ${Math.random() * 255}, 0.8),
                            rgba(0, 0, 0, 0))`,
                        animation: `float ${Math.random() * 10 + 5}s linear infinite`,
                        animationDelay: `${Math.random() * -10}s`
                    }}
                />
            ))}

            {/* Scanlines effect */}
            <div
                className="absolute inset-0 pointer-events-none"
                style={{
                    background: 'repeating-linear-gradient(0deg, rgba(0,0,0,0.2) 0px, rgba(0,0,0,0.2) 1px, transparent 1px, transparent 2px)',
                    backgroundSize: '100% 2px',
                    animation: 'scanline 1s steps(60) infinite'
                }}
            />

            {/* Add the animations */}
            <style>
                {`
                    @keyframes gridMove {
                        0% {
                            transform: perspective(500px) rotateX(60deg) translateY(0);
                        }
                        100% {
                            transform: perspective(500px) rotateX(60deg) translateY(40px);
                        }
                    }

                    @keyframes float {
                        0%, 100% {
                            transform: translate(0, 0) rotate(0deg);
                        }
                        25% {
                            transform: translate(10px, -10px) rotate(90deg);
                        }
                        50% {
                            transform: translate(0, -20px) rotate(180deg);
                        }
                        75% {
                            transform: translate(-10px, -10px) rotate(270deg);
                        }
                    }

                    @keyframes scanline {
                        0% {
                            background-position: 0 -100vh;
                        }
                        100% {
                            background-position: 0 100vh;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default RetroBackground;